import {useParams} from '@aboutyou/router';

export const useCategoryId = (): number | undefined => {
  const {categoryId} = useParams<{categoryId?: string}>();
  const categoryIdNumber = Number(categoryId);

  if (isNaN(categoryIdNumber)) {
    return undefined;
  }

  return categoryIdNumber;
};
